import {useAuth} from "react-oidc-context";
import {
  hasAnyAdminGroup,
  hasHighTierGroup,
  hasProfessionalGroup,
  hasPaidGroupOrOrg,
  getUserTierFromGroupsAndOrg,
} from "@breachrx/common/packageTiers";

export const buildOidcConfig = (overrides = {}) => ({
  client_id: process.env.AUTH_CLIENT_ID || "brx-legacy-client",
  authority: process.env.AUTH_AUTHORITY || "https://id.development.breachrx.io/realms/breachrx",
  redirect_uri: typeof window !== "undefined" ? window.location.origin : "",
  scope: process.env.AUTH_SCOPE || "openid cognito profile email",
  post_logout_redirect_uri: typeof window !== "undefined" ? window.location.origin : "",
  ...overrides,
});

export const deriveRegScoutPlan = (groups = []) => {
  // packageTiers helpers key off a user object's cognito:groups (centralized in @breachrx/common).
  const user = {"cognito:groups": groups};
  const isAdmin = hasAnyAdminGroup(user);
  const isHighTier = hasHighTierGroup(user);
  const isPaid = hasPaidGroupOrOrg(user);
  const isProfessional = hasProfessionalGroup(user) && !isAdmin && !isHighTier;
  const needsUpgrade = !isPaid;
  const currentPlanForDisplay = getUserTierFromGroupsAndOrg(user);

  return {isAdmin, isHighTier, isPaid, isProfessional, needsUpgrade, currentPlanForDisplay};
};

export const useKeycloakUser = () => {
  const auth = useAuth();
  const profile = auth.user?.profile || {};
  const groups = profile["cognito:groups"] || [];

  const user = auth.user ?
    {
      IdToken: auth.user.id_token,
      AccessToken: auth.user.access_token,
      RefreshToken: auth.user.refresh_token,
      username: profile.preferred_username || profile.email,
      email: profile.email,
      profile,
    } :
    {};

  return {user, groups, isLoading: auth.isLoading};
};
